import { useState } from 'react';
import { ConfirmPopup, Icon, Text, WarningBanner } from '~/commonComponents';
import { DomainDecommissioning } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { Colors } from '~/themes/colors';
import { useDomainRedirection, useDomainWhitelisted } from './hooks';
import { NumberUtils } from '~/utils/NumberUtils';

export const DomainDecommissioningWarningBanner = () => {
  const isEnabled = useFeatureFlag(DomainDecommissioning);

  const [isOpen, setOpen] = useState(false);

  const { onOpenNewSite, onOpenResetPassword } = useDomainRedirection();
  const { isWhitelisted, targetUrl } = useDomainWhitelisted();

  if (!isEnabled || !isWhitelisted) return null;

  return (
    <>
      <WarningBanner
        dataCy='domain-decommissioning-warning'
        description={
          <span>
            We’re updating our web address to{' '}
            <Text bold color={Colors.neutral_600}>
              <u>{targetUrl?.replace('https://', '')}</u>
            </Text>
            . Click here to learn what you need to do.
          </span>
        }
        containerStyle={{ paddingRight: 16, marginBottom: 0 }}
        descriptionStyle={{ flex: 1, display: 'block' }}
        onClick={() => setOpen(true)}
        primaryColor={Colors.error_500}
        secondaryColor={Colors.error_50}
        showRightArrow
      />

      {isOpen && (
        // @ts-expect-error the component still written in JavaScript
        <ConfirmPopup
          rightButtonAction={onOpenNewSite}
          leftButtonAction={onOpenResetPassword}
          rightButtonText="Open New Site"
          leftButtonText="Reset Password"
          title="GoTu URL Update"
          titleStyle={{ marginTop: 20 }}
          modalStyle={{
            width: '640px',
          }}
          description={
            <article>
              We’re updating our web address to{' '}
              <strong>{targetUrl?.replace('https://', '')}</strong>. This site will redirect
              automatically soon.
              <br />
              <br />
              To prepare, please complete the following steps beforehand:
              <ol>
                <li>
                  Go to <strong>{targetUrl?.replace('https://', '')}</strong> and log in using your
                  existing credentials
                </li>
                <li>Save your password in your browser</li>
                <li>Bookmark the new site for easy access</li>
              </ol>
              <br />
              Need to reset your password? Reset it in the button below.
              <br />
              <br />
              For questions or assistance, please contact customer support by texting or calling{' '}
              {NumberUtils.getCSPhone().formatted}.
            </article>
          }
          descriptionStyle={{
            textAlign: 'left',
          }}
          Icon={() => <Icon name="warning-outline" color="error_500" size={80} />}
          closePopup={() => setOpen(false)}
          showClosePopupIcon
          leftButtonStyle={{ width: 196 }}
          rightButtonStyle={{ width: 196 }}
        />
      )}
    </>
  );
};
